module.exports = __webpack_public_path__ + "img/preloader-agent.66a5edce.svg";